import { render, staticRenderFns } from "./UserCollection.vue?vue&type=template&id=de3f167c&"
import script from "./UserCollection.vue?vue&type=script&lang=js&"
export * from "./UserCollection.vue?vue&type=script&lang=js&"
import style0 from "./UserCollection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
